import { syncStcSelectDisplay } from '../../utils/stc-select';

export type ResidencyResidentsFilterDraft = {
  cluster: string;
  direction: string;
};

export interface SelectOption {
  label: string;
  value: string;
  selected: boolean;
  disabled: boolean;
}

export function getResidencyResidentsScope(): ParentNode {
  return document.querySelector<HTMLElement>('[data-barba-namespace="residency"]') ?? document;
}

export function readResidencyResidentsFilterDraft(root: ParentNode): ResidencyResidentsFilterDraft {
  const cluster = root.querySelector<HTMLSelectElement>('#residencyResidentsCluster')?.value ?? '';
  const direction =
    root.querySelector<HTMLSelectElement>('#residencyResidentsDirection')?.value ?? '';

  return { cluster, direction };
}

export function applyResidencyResidentsFilterDraft(
  root: ParentNode,
  draft: ResidencyResidentsFilterDraft,
  options: { silent?: boolean } = {},
): void {
  const clusterSelect = root.querySelector<HTMLSelectElement>('#residencyResidentsCluster');
  const directionSelect = root.querySelector<HTMLSelectElement>('#residencyResidentsDirection');

  if (clusterSelect) {
    clusterSelect.value = draft.cluster;
    if (options.silent) {
      syncStcSelectDisplay(clusterSelect);
    } else {
      clusterSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (directionSelect) {
    directionSelect.value = draft.direction;
    if (options.silent) {
      syncStcSelectDisplay(directionSelect);
    } else {
      directionSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

export function hasActiveResidencyResidentsDrawerFilters(root: ParentNode): boolean {
  const draft = readResidencyResidentsFilterDraft(root);

  return Boolean(draft.cluster || draft.direction);
}

export function draftsEqual(
  left: ResidencyResidentsFilterDraft,
  right: ResidencyResidentsFilterDraft,
): boolean {
  const clusterEqual = left.cluster === right.cluster;
  const directionEqual = left.direction === right.direction;

  return clusterEqual && directionEqual;
}

export function getSelectOptions(selectId: string): SelectOption[] {
  const select = document.getElementById(selectId);

  if (!(select instanceof HTMLSelectElement)) {
    return [];
  }

  return [...select.options].map((option) => ({
    label: option.text.trim(),
    value: option.value,
    selected: option.selected,
    disabled: option.disabled,
  }));
}
